<template>
  <div class="flex flex-col gap-2 p-4">
    <div class="font-medium uppercase">
      <FontAwesomeIcon :icon="faCheckCircle" />
      {{ $t('components.projects.statusTaskControl.awaitingPlanning.title') }}
    </div>
    <p
      v-if="currentUser.roles.includes('admin:skyloud')"
      class="text-sm"
    >
      {{ $t('components.projects.statusTaskControl.awaitingPlanning.clientAccepted') }} ✅
    </p>
    <div v-else>
      <p class="text-sm">{{ $t('components.projects.statusTaskControl.awaitingPlanning.thanksForConfidence') }}</p>
      <p class="mt-2 text-sm">{{ $t('components.projects.statusTaskControl.awaitingPlanning.requestProcessedSoon') }}</p>
    </div>
    <WaitingButtonsControl
      v-if="currentUser.roles.includes('admin:skyloud')"
      :task="task"
    />
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import { faCheckCircle } from '@fortawesome/pro-light-svg-icons';
import WaitingButtonsControl from '@/modules/projects/components/TaskControls/WaitingButtonsControl.vue';

defineProps({
  task: {
    type: Object,
    required: true,
  },
});

const store = useStore();
const currentUser = computed(() => store.getters['auth/currentUser']);
</script>
